import { createFileRoute } from '@tanstack/react-router';
import { CmsNavManagerPage } from '@pages/website';

/** CMS Navigation-Manager (/website/navigation) */
export const Route = createFileRoute('/_authenticated/website/navigation')({
  component: CmsNavManagerPage,
});
